import React from "react";

import { DeliverType1, PaginationType1, EmptyResultsMessage } from "./styled";
import { Spinner } from "styles/App.styled";
import { useDispatch, useSelector } from "react-redux";
import { searchOnSite } from "api/api";
import {
  setSearchedRecipes,
  setLoading,
  getSearchValue,
  saveSearchedRecipes,
  getSearchedRecipes,
  isSearchingLoading,
} from "store/searchReducer";
import TemplateForRecipes from "../../shared/Slider/fragment/templateForRecipes";
import { Card, Column } from "../../styles/MainCards.styled";
import Pagination from "../Pagination";
import { RecipesCardsWrap } from "components/ProfilePage/Products/styled";

function SearchDisplay() {
  const isLoading = useSelector(isSearchingLoading);
  const recipes = useSelector(getSearchedRecipes);
  const searchValue = useSelector(getSearchValue);
  const dispatch = useDispatch();

  const searchPageRequest = (pagination) => {
    dispatch(setLoading(true));
    searchOnSite(searchValue, pagination)
      .then((res) => {
        dispatch(setSearchedRecipes(res.data));
        dispatch(setLoading(false));
      })
      .catch((err) => console.log(err));
  };

  if (isLoading) return <Spinner />;

  return (
    <>
      <RecipesCardsWrap>
        {recipes.results.length > 0 ? (
          recipes.results.map((recipe) => (
            <Column key={recipe.id}>
              <Card>
                <TemplateForRecipes item={recipe} type="recipes" context="recipe" setSaved={saveSearchedRecipes} />
              </Card>
            </Column>
          ))
        ) : (
          <EmptyResultsMessage>Your search did not match</EmptyResultsMessage>
        )}
      </RecipesCardsWrap>
      <DeliverType1 />
      <PaginationType1>
        <Pagination stepClick={searchPageRequest} countOfElements={recipes.count} />
      </PaginationType1>
    </>
  );
}

export default SearchDisplay;
